import { QUICK_INTEGRATION_CONTINUE, QUICK_INTEGRATION_SAVE_ASYNC } from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    successQuickIntegration: null,
    data: {},
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case QUICK_INTEGRATION_CONTINUE:
        return { ...state, data: action.payload.data }
      case QUICK_INTEGRATION_SAVE_ASYNC.INITIATE:
        return { ...state, loader: true }
      case QUICK_INTEGRATION_SAVE_ASYNC.SUCCESS:
        return { ...state, loader: false, successQuickIntegration: true }
      case QUICK_INTEGRATION_SAVE_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      default:
        return state
    }
  }
}
